import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class ITOpsService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }
      
    async insertBqChargeback(data) {
        const pos = getPosition();
        const response = await API.service('insertBqChargeback', data, pos, this.changeAlert, null, null);

        return response?.data
    }
}